import React, { useState, useEffect, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import BohfisLogo from '../images/LogoBohfis.png'
// Components
// Importamos el componente que renderiza las publicaciones y los modales
import { Menu_derecha_home } from "../components/Menu_derecha_home";
import { GlobalPublications } from "./GlobalPublications";
import { useProovedorData, returnFullURL, ProfileContent, countries } from "../components";

import LinkIcon from '@mui/icons-material/Link';
import QrCodeIcon from '@mui/icons-material/QrCode';
import GroupIcon from '@mui/icons-material/Group';
import Shopping from '@mui/icons-material/LocalGroceryStore';
import { SupportAgent } from '@mui/icons-material';

import "../css/hosming/inicio_styles.css";
import "../css/global/publication-styles.css";
// import "../css/meprofile.css";
import MyCompanyUpdate from "../components/MyCompanyUpdate.js";
import { ModalForAll } from "../components/global/ModalForAll.js";
import { ImagenesGlobal } from "../components/global/ImagenesGlobal.js";

export const HomeHosming = () => {
	const { loading,
		data_user,
		main_data,
		temporalNewCompany,
		setTemporalNewCompany,
		reloadMyCompanys,
		loadImageS,
		token_local,
		setShowLogin
	} = useProovedorData() || [];

	const styles_icons = {
		backgroundColor: 'var(--empresa-color)',
		color: 'var(--theme-main)',
		padding: '6px',
		borderRadius: '50%',
		overflow: 'hidden',
		fontSize: 'var(--same-size) !important',
	};

	const [loadingRequests, setLoadingRequests] = useState({
		publications: false,
		companys: false,
	});

	useEffect(() => {
		sessionStorage.removeItem('pichi');
	}, [loading]);

	const [stateModalAddCompany, setStateModalAddCompany] = useState(false);
	// href="https://wa.me/59162997217" target="_blank"

	return (
		<div id="main-page" className="main-page">
			<div className="global-options data-global">
				<ul className="data-profile">
					<li style={{ width: '100%' }}>
						{
							data_user?.authCode ? (
								<NavLink to={"user/posts"} >
									<ProfileContent profile_url={data_user ? data_user?.perfil : null} loadImageS={loadImageS} style={{ height: '100%' }} />
									<span className="normal-black text-bold">{data_user?.fullname ?? "Sin nombre..."}</span>
								</NavLink>
							) : (
								<button className="default-buttons" onClick={() => setShowLogin(true)}>
									<ProfileContent profile_url={data_user ? data_user?.perfil : null} loadImageS={loadImageS} style={{ height: '100%' }} />
									<span className="normal-black text-bold">{data_user?.fullname ?? "Sin nombre..."}</span>
								</button>
							)
						}

					</li>

					<li style={{ width: '100%' }}>
						<NavLink to={"products"} >
							<Shopping className='li-icon' style={styles_icons} />

							<span className="normal-black text-bold">Compras</span>
						</NavLink>
					</li>

					<li style={{ width: '100%' }}>
						<NavLink to={"company"} >
							<GroupIcon className='li-icon' style={styles_icons} />

							<span className="normal-black text-bold">Empresas</span>
						</NavLink>
					</li>
				</ul>

				<ul className="data-companys">
					{
						((main_data?.companys && main_data?.companys) || []).map(data => (
							<li>
								<NavLink to={data.nit ? ("/administrar/negocio/productos/" + data.nit) : "/"} style={{ width: '100%' }}>
									<ImagenesGlobal url={data?.logo} type="cover" loadImageS={loadImageS} alt={data.nameComany} />
								</NavLink>
							</li>
						))
					}
				</ul>
			</div>

			<div className="central-main-content">
				<a href="https://bohfis.com" target="_blank" className="default-buttons shadow-lvl6 "
					style={{
						height: 'min-content',
						background: 'linear-gradient(6deg,#ffffff -200%, #202020 100%)',
						width: '100%',
						padding: '10px',
						borderRadius: '15px',
						justifyContent: 'space-around'
					}}>
					<img src={BohfisLogo} alt="logo bohfis" style={{ width: '250px' }} />
					<ul>


						<li><LinkIcon style={{transform:'rotate(55deg)'}}/> Multi-Links personalizados</li>
						<li><QrCodeIcon /> Tarjetas Digitales (QR y Link)</li>
					</ul>
				</a>
				{
					(main_data?.companys ?? []).length == 0 && (
						<div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
							<button className="default-buttons" onClick={() => token_local.length > 90 ? setStateModalAddCompany(true) : setShowLogin(true)} style={{
								backgroundColor: 'var(--empresa-color)',
								color: 'var(--theme-main)',
								fontSize: '18px',
								height: 'min-content',
								padding: '10px',
								width: '80%',
								borderRadius: '15px',
								fontWeight: '550',
							}}>Crear sistema de ventas</button>

							<a href="https://wa.me/59177722681?text=Hola!%20Busco%20atencion%20de%20soporte,%20podria%20ayudarme?" target="_blank" className="default-buttons" style={{
								backgroundColor: 'var(--empresa-color)',
								color: 'var(--theme-main)',
								padding: '10px',
								fontSize: '18px',
								width: '15%',
								borderRadius: '15px',
								fontWeight: '550',
							}}><SupportAgent style={{ fontSize: '35px' }} /></a>
						</div>
					)
				}

				<GlobalPublications where="main" />
			</div>

			<div className="global-options ads-hosming">
				<Menu_derecha_home />
			</div>

			{
				<ModalForAll stateModal={stateModalAddCompany} setStateModal={setStateModalAddCompany} className="modal-login">
					<MyCompanyUpdate closeModal={setStateModalAddCompany}
						dataCompanyProvider={temporalNewCompany} setDataCompanyProvider={setTemporalNewCompany} reloadData={reloadMyCompanys}
					/>
				</ModalForAll>
			}
		</div>
	);
};
